export default __webpack_public_path__ + "static/media/home-banner1.6427af9a.png";